import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Box, Typography } from '@mui/material';
import { apiGetById } from '../../services/genesisApi/httpsMethods';
import type { FC } from 'react';
import type { Tenant } from '../../types/deal';
import { SimpleToolbar } from '../../components/layout/Toolbar';
import { CustomButton } from '../../components/common/customButton';
import { TenantDetail } from './Tenant';


interface TenantWrapperProps {
  id?: number;
}

const TenantWrapper: FC<TenantWrapperProps> = ({ id }) => {
  const navigate = useNavigate();
  const params = useParams<{ tenantId?: string }>();
  const tenantId = id ?? (params.tenantId ? parseInt(params.tenantId) : undefined);

  const [tenant, setTenant] = useState<Tenant | null>(null);

  useEffect(() => {
    if (!tenantId) return;

    apiGetById('tenant', tenantId)
      .then((data) => {
        setTenant(data.data[0]);
      })
      .catch((err) => {
        console.error('Failed to fetch tenant', err);
      });
  }, [tenantId]);

  if (!tenantId) return <Typography>Tenant ID not found.</Typography>;
  if (!tenant) return <Typography>No Tenant found.</Typography>;

  return (
    <Box sx={{ position: 'relative', zIndex: 1 }}>
      <Box
        sx={{
          position: 'sticky',
          zIndex: 10,
        }}
      >
        <SimpleToolbar>
          <CustomButton
            handleButtonPress={() => { navigate(`/tenants/${tenantId}/edit`); }}
            isButtonDisabled={false}
            text="Edit Tenant"
            isLoading={false}
            isLoadingText="Loading"
            solid={false}
            widthOverride="100px"
            data-position="right"
          />
        </SimpleToolbar>
      </Box>
      <Box sx={{ padding: 2, marginBottom: 100, zIndex: 100 }}>
        <TenantDetail tenant={tenant} isEdit={true} />
      </Box>
    </Box>
  );
};

export default TenantWrapper;
